import { SVGProps } from 'react';

export type ArrowForwardIconProps = SVGProps<SVGSVGElement>;

export const ArrowForwardIcon = (props: ArrowForwardIconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4285_214)">
      <path
        d="M7.6665 -0.333496L6.2565 1.0765L11.8365 6.6665H-0.333496V8.6665H11.8365L6.2565 14.2565L7.6665 15.6665L15.6665 7.6665L7.6665 -0.333496Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4285_214">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
